import MainLayout from "@/components/layout/MainLayout.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { required, maxLength } from "vuelidate/lib/validators";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    name: "editContent",

    components: {
        MainLayout
    },

    data() {        
        return {
            id: null,
            courseId: null,
            contentRequestForm: {
                course_id: "",                
                course_title: "",
                gp_name: "",
                content_title: "",
                content_details: "",
            },
            submitted: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "bulletedList",
                    "numberedList"
                ]
            }
        };
    },

    validations: {
        contentRequestForm: {
            course_title: {
                required,
                maxLength: maxLength(100)
            },
            gp_name: {
                required,
                maxLength: maxLength(100)
            },
            // content_title: {
            //     required,
            //     maxLength: maxLength(100)
            // },
            // content_details: {
            //     required,
            //     maxLength: maxLength(5000)
            // },
        }
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        submit() {
            this.submitted = true;
            if (this.$v.contentRequestForm.$invalid) {
                return;
            }
            this.editContent();
        },

        editContent() {
            var request = {
                // course_id: this.contentRequestForm.course_id,
                group_name: this.contentRequestForm.gp_name,
                // content_title: this.contentRequestForm.content_title,
                // content_details: this.contentRequestForm.content_details,
                // group_id: this.contentRequestForm.group_id
            }
            axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/update", JSON.stringify(request), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then(() => {
                    this.$router.push({name: 'contentGroup', params: { id: this.courseId }})
                    this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
        },

        getCourseName() {
            axios.get("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id  )
                .then((response) => {      
                    this.courseId = response.data.course_id;
                    this.contentRequestForm.course_id = response.data.course_id;
                    this.contentRequestForm.course_title = response.data.course_title;
                    this.contentRequestForm.gp_name = response.data.gp_name;
                    // this.contentRequestForm.content_title = response.data.content_title;
                    // this.contentRequestForm.content_details = response.data.content_details;
                    this.contentRequestForm.group_id = response.data.id;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });                        
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Name API error", error);
                });
        },
        goToContentGroup() {
            this.$router.push({ name: 'contentGroup', params: {id: this.courseId } });
        }
    },
    
    mounted() {
        this.id = this.$route.params.id;
        this.courseId = this.$route.params.courseId;
        this.getCourseName();
    }
};
